// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"532":"styles","678":"component---src-pages-index-js","774":"framework"}[chunkId] || chunkId) + "-" + {"217":"9f40526f4ad44cf636a4","231":"78a9dd2e8006894332af","532":"99672981795d8c2aca4e","678":"e307b6222bcbc7c65eaf","774":"460167880b492b0fb494"}[chunkId] + ".js";
};